<div class="ion-margin ion-text-center">
  <ion-icon *ngIf="!!icon" [name]="icon" [color]="color" class="xl"></ion-icon>
  <h1 *ngIf="!!title" class="ion-margin-vertical">
    <ion-text [color]="color">{{ title | translate }}</ion-text>
  </h1>
  <p *ngIf="!!message" class="ion-margin-vertical">
    <ion-text>{{ message | translate }}</ion-text>
  </p>
  <ng-content></ng-content>
</div>